import React from 'react'
import classNames from 'classnames'
import styles from '../styles'

const CellDiv = (props) => (
  <div
    style={{ width: props.width }}
    className={classNames(styles.cell, props.className)}
  >
    {props.children}
  </div>
)


CellDiv.propTypes = {
  className: React.PropTypes.string,
  width: React.PropTypes.string,
  children: React.PropTypes.node,
}

export default CellDiv



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataCell/cellDiv.jsx